import { render, staticRenderFns } from "./PageBilling.vue?vue&type=template&id=4c5f45f9&"
import script from "./PageBilling.vue?vue&type=script&lang=js&"
export * from "./PageBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports